import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ApplicationFormDataService } from '@app/application/application-form/application-form-data.service';
import { ApplicationFormService } from '@app/application/application-form/application-form.service';
import { SlideCommonService } from '@app/application/common/slide-common.service';

@Component({
    selector: 'app-slide',
    templateUrl: './slide.component.html',
    imports: [
        CommonModule,
        NgIf
    ]
})
export class ConnectSlideComponent {
    @Input() title: string | undefined;
    @Input() supportingText: string | undefined;
    @Input() slideNumber: string | undefined;
    @Input() finalSlide = false;
    @Input() active = false;
    @Input() slideCompleted = false;
    @Input() onTitleClick: () => void = () => { this.afs.debugSlide() };

    hasOnTitleClick = false;

    onSelected(obj: any) {
        console.log('slide onSelected ' + JSON.stringify(obj));
    }
    constructor(private cdr: ChangeDetectorRef, private afs: ApplicationFormService, private afds: ApplicationFormDataService, private scs: SlideCommonService) {

    }
}
